import { routesNames } from '@/core/constants'
import desentranhamentoRoutes from '@/views/routers/routes/adesao/processo-digital/desentranhamento/desentranhamento'
import ModalDesentranhamentoGenericoView from '@/views/components/documentos/desentranhar/ModalDesentranhamentoGenericoView'
import TipoModeloDocumento from '@/core/constants/tipo-modelo-documento'

export default [
	{
		name: routesNames.ADESAO.PROCESSO_DIGITAL.DESENTRANHAMENTO.DESENTRANHAR_DOCUMENTO_PROCESSO_DIGITAL_VIEW,
		path: '/adesao/:id/processo-digital/:idTermo/desentranhar/',
		component: ModalDesentranhamentoGenericoView,
		props: route => ({
			rotaVoltarParaListagem: routesNames.ADESAO.ADERENTE.ADESAO_VIEW,
			parametrosRotaVoltarParaListagem: { id: route.params.id, tipoAcesso: 'editar' },
			tipoDocumento: TipoModeloDocumento.ADESAO
		}),
		children: [...desentranhamentoRoutes],
	},
]
